import { createRouter, createWebHistory } from "vue-router";
import NProgress from "nprogress";
import { authBasicCheck } from "@/api/v1/auth";
import { storeToRefs } from "pinia";
import { useAuthStore } from "@/stores/auth";

export const routes = [
  {
    path: "/",
    component: () => import("@/layout"),
    children: [
      {
        path: "/",
        name: "CV",
        component: () => import("@/views/cv"),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  linkActiveClass: "active",
  mode: "history",
  routes,
  scrollBehavior: (to) => {
    if (to.hash) {
      return { el: to.hash };
    } else {
      return { top: 0 };
    }
  },
});

// middleware route
router.beforeEach(async (to, from, next) => {
  // Step 1: start progress bar
  NProgress.start();

  next();
});

export default router;
